import { Sites } from '@ps/platform-message-framework/common/Sites';
import { FeatureFlag } from '@ps/web-core-enums';
import { select, useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import useRmfFirstScreenBackButton from '../../../../hooks/useRmfFirstScreenBackButton';
import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import DOB from '../../../DOB/DOB';
import useRmfFirstScreen from '../../hooks/useRmfFirstScreen';
import useTransitionScreenHandler from '../../hooks/useTransitionScreenHandler';
import RMFTransitionScreen from '../RMFTransitionScreen/RMFTransitionScreen';

import {
  TXTWCL_How_old_are_youX,
  TXTWCL_We_need_your_date_of_birth_to__ELL,
  TXTWCL_When_were_you_bornX
} from './RMFDOB.messages.json';

const RMFDOB: React.FC = () => {
  const isSumSubEnabled = useFeature(FeatureFlag.SwcSignupRmfSumSub);
  const isAutofocusEnabled = useFeature(FeatureFlag.SwcSignupRmfAutofocus);
  const legalAge = useSelector(select.cms.getLegalAge);
  const [shouldAutoFocus, setShouldAutoFocus] = useState(false);
  const [isTransitionVisible, closeTransitionScreen] = useTransitionScreenHandler();
  const isFirstScreen = useRmfFirstScreen();
  const isItaly = useSelector(select.cms.getSiteId) === Sites.ITA;
  const { showBackButton, handleClick } = useRmfFirstScreenBackButton();

  useEffect(() => {
    if (isTransitionVisible !== undefined) {
      setShouldAutoFocus(isAutofocusEnabled && !isTransitionVisible);
    }
  }, [isAutofocusEnabled, isTransitionVisible]);

  return (
    <Container
      page={RMFDOB}
      headerProps={{
        title: <Translation {...TXTWCL_When_were_you_bornX} />,
        buttons: {
          back: (!isFirstScreen && !isSumSubEnabled) || isItaly || showBackButton,
          onBackClick: handleClick
        }
      }}
      pageTopTitle={<Translation {...TXTWCL_How_old_are_youX} />}
      pageTopSubtitle={
        <Translation {...TXTWCL_We_need_your_date_of_birth_to__ELL} values={{ 0: legalAge }} />
      }
    >
      <fieldset>
        <DOB hasBeenShown={shouldAutoFocus} />
      </fieldset>
      <CTAButton />
      {isTransitionVisible && !isSumSubEnabled && (
        <RMFTransitionScreen handleButtonClick={closeTransitionScreen} />
      )}
    </Container>
  );
};

RMFDOB.displayName = 'RMFDOB';

export default RMFDOB;
